module.exports = __webpack_public_path__ + "ProximaNova-Extrabld.woff?ccf59c77109aecc8deeeede82e3bac87";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Extrabld.woff
// module id = 42
// module chunks = 0